import React, { useState, useEffect, useContext } from 'react';
import lo from 'lodash';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {WfpFrame} from "./core/wfpFrame";
import { IntroStep, ConfirmationStep, PaymentStep, AcknowledgementStep, SubmissionStep } from './core/layoutElements';
import { getForms, setFormObj, setIsFetching } from './core/reducers/wfpSessionReducer';
import { handleAppCallback } from './core/reducers/formDetail';
import '../css/index.css';
import '../css/wfp/index.css';
import '../css/wfp/input.css';
import '../css/wfp/nav.css';
import { RootContext } from './root';
import { dialogHelper } from './core/dialogHelper';
import { EMEFieldsMapping } from './core/reducers/emeFieldsMapping';
import { setUseEME } from './core/reducers/wfpEMESessionReducer';

export const Form = ({ formId, form /*intro, steps, l10n, submitTransformFunc, signRequired*/, currentLang, validation }) => {
	const [curlang, setCurlang] = useState(); 
	const { language, formList } = useSelector(store => store.session, lo.isEqual);
	const { recaptcha } = useContext(RootContext);
	const dispatch = useDispatch();
	const { localization, steps, signRequired, signFields, paymentRequired} = form;
	const { formData } = useSelector(store => store.formDetail);
	const history = useHistory();
	const store = useStore();

	if (currentLang !== curlang) {
		setCurlang(currentLang);
		localization.setLanguage(currentLang);

		document.title = localization.formTitle + " - " + localization.documentTitle;
	}

	useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const paramNames = ['code', 'RefID', 'state', 'error_code'];
        const paramData = Object.fromEntries(paramNames.map(name => [name, params.get(name)]));

        if (Object.values(paramData).some(value => value !== null)) {
            dispatch(handleAppCallback(
				paramData, 
                (response) => {
					// dispatch(dialogHelper.showMessageDialog({
                    //     message: language.loginSuccess,
					// 	title: language.loginSuccess,
                    //     handleClose: () => {
                    //         paramNames.forEach(name => params.delete(name));
                    //         history.replace({ search: params.toString() });	
                    //     }
                    // }, language));
					paramNames.forEach(name => params.delete(name));
					history.replace({ search: params.toString() });	
                },
                (err) => {
					paramNames.forEach(name => params.delete(name));
					history.replace({ search: params.toString() });	
					// dispatch(dialogHelper.showErrorDialog({
                    //     err: language.loginFailed,
                    //     handleClose: () => {
                    //         paramNames.forEach(name => params.delete(name));
                    //         history.replace({ search: params.toString() });
                    //     }
                    // }, language));
                }
            ));
        }
    }, [dispatch, history, language]);
/*
	useEffect(() => {
		dispatch(setIsFetching());
		window.grecaptchaOnVerify = token => {
 			dispatch(getForms(token));
		}
		recaptcha().reset();
		recaptcha().execute();
	}, [dispatch]);

	useEffect(() => {
		for (let i=0; i<formList.length; i++) {
			if (formList[i].code === formId) {
				dispatch(setFormObj(formList[i]));
			}
		}
	}, [formId, formList, dispatch]);
*/

	useEffect(() => {
		dispatch(setFormObj(form));
		if (EMEFieldsMapping[form.code]) {
			dispatch(setUseEME(true));
		}
	},[])

	let formSteps = [];
	
	if (!form.simplifiedForm) {
		// Standard
		formSteps.push(IntroStep(language));
		formSteps.push(...steps);
		formSteps.push(ConfirmationStep(steps, signRequired, paymentRequired, localization, formId, signFields, form));
		formSteps.push(SubmissionStep(form, formData));
		// if (paymentRequired) { formSteps.push(PaymentStep) }
		formSteps.push(AcknowledgementStep);	
	} else {
		// Customized
		//formSteps.push(IntroStep(language));
		formSteps.push(...steps);
		//formSteps.push(ConfirmationStep(steps, signRequired, paymentRequired, localization, formId, signFields, form));
		//formSteps.push(SubmissionStep(form, formData));
		// if (paymentRequired) { formSteps.push(PaymentStep) }
		if (form.code != "SUPPLINK") { formSteps.push(AcknowledgementStep); }
	}

	return (
		<WfpFrame screenTitle={localization.formTitle}
			steps={formSteps}
			form={form}
			formData={formData}
			/*
			intro={intro} l10n={l10n} submitTransformFunc={submitTransformFunc} validation={validation} signRequired={signRequired}
			*/  
			/>
	)
}

export default Form;
